"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = exports.UserProvider = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var LaunchpadProvider_1 = require("../../../LaunchpadProvider");
var useERC20_1 = require("../../../contracts/useERC20");
var useWeb3_1 = require("../../../shared/hooks/useWeb3");
var utils_1 = require("../../../shared/utils");
var kyc_1 = require("./kyc");
var init = {
    account: undefined,
    funds: new bn_js_1.default('0'),
    tokens: new bn_js_1.default('0'),
    kyc: {
        status: 'nothing',
        formUrl: '',
        country: '',
        declineReasons: [],
    },
    refresh: function () {
        // nothing
    },
};
function useUserRaw(_a) {
    var getKYCStatus = _a.getKYCStatus, kycCacheKeyBase = _a.kycCacheKeyBase;
    var mainToken = (0, LaunchpadProvider_1.useLaunchpadProvider)().mainToken;
    var _b = (0, useWeb3_1.useWeb3Provider)(), web3 = _b.connectedWeb3, staticWeb3 = _b.staticWeb3, web3Account = _b.account;
    var token = (0, useERC20_1.useERC20)(mainToken.address, staticWeb3);
    var _c = (0, react_1.useState)(init), user = _c[0], setUser = _c[1];
    var _d = (0, react_1.useState)(web3Account), account = _d[0], setAccount = _d[1];
    (0, react_1.useEffect)(function () {
        setAccount(web3Account);
    }, [web3Account]);
    (0, react_1.useEffect)(function () {
        // @ts-expect-error support impersonating
        window.__SECRETLY_SET_ACCOUNT = function (acc) { return setAccount(acc); };
    }, []);
    /**
     * Fetch user data on account change.
     */
    (0, react_1.useEffect)(function () {
        if (!account || !staticWeb3 || !token) {
            setUser(init);
            return;
        }
        // Load user data
        refresh();
    }, [staticWeb3, account, token]);
    (0, react_1.useEffect)(function () {
        if (account && web3) {
            web3.eth.getBalance(account).then(function (v) {
                setUser(function (user) { return (__assign(__assign({}, user), { funds: new bn_js_1.default(v) })); });
            });
        }
    }, [account, web3]);
    function refresh(withKyc) {
        if (withKyc === void 0) { withKyc = true; }
        token.methods
            .balanceOf(account)
            .call({ from: account })
            .then(function (value) {
            var userTokens = (0, utils_1.normalizeDecimals)(new bn_js_1.default(value), mainToken.decimals);
            setUser(function (user) { return (__assign(__assign({}, user), { tokens: userTokens })); });
        })
            .catch(function (err) { return console.error('Error balanceOf', err); });
        if (withKyc && getKYCStatus) {
            (0, kyc_1.getCachedKYCStatus)(account, getKYCStatus, kycCacheKeyBase).then(function (_a) {
                var status = _a.status, formUrl = _a.formUrl, country = _a.country, declineReasons = _a.declineReasons;
                setUser(function (oldUser) { return (__assign(__assign({}, oldUser), { kyc: {
                        status: status,
                        formUrl: formUrl,
                        country: country,
                        declineReasons: declineReasons,
                    } })); });
            });
        }
    }
    var invalidateCachedKYC = (0, react_1.useCallback)(function () {
        var canCache = typeof window.localStorage !== 'undefined';
        if (!canCache)
            return;
        var key = "".concat(account, "-kyc");
        window.localStorage.removeItem(key);
    }, [account]);
    return __assign(__assign({}, user), { account: account, refresh: refresh, invalidateCachedKYC: invalidateCachedKYC });
}
var _a = (0, constate_1.default)(useUserRaw), UserProvider = _a[0], useUser = _a[1];
exports.UserProvider = UserProvider;
exports.useUser = useUser;
